import { useField } from "formik";

import "./InputBorderModal.scss";

const InputBorderModal = ({ label, isModal, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className="input-modal-content">
      <label className="input-modal-content-label paragraph-gray-reg-14">
        {label}
      </label>

      <input
        className={`${isModal ? "border-gray" : ""} input-modal-field`}
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="input-modal-error-field">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default InputBorderModal;
